import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { GetBasicReservationInformationStoreModule } from '../../store';
import { GetBasicReservationInformationStoreService } from './get-basic-reservation-information-store.service';

@NgModule({
  providers: [GetBasicReservationInformationStoreService],
  imports: [GetBasicReservationInformationStoreModule, EffectsModule.forRoot()],
})
export class GetBasicReservationInformationStoreServiceModule {}
